module.exports = __webpack_public_path__ + "img/unavailable-location-opacity.78880942.svg";